import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../../state/modals-dux';
import Loading from './Loading';
import fetchDux from '../../state/fetch-dux';


const ValidateAddressModal = ({
  openModal,
  closeModal,
  postValidateAddressResult,
  clearPostValidateAddress,
  states,
  hasAlcohol,
  formValues,
  onSubmit,
  submitInProgress
}) => {
  const {
    inProgress: postValidateAddressInProgress,
    error,
    result
  } = postValidateAddressResult || {};

  const inProgress = submitInProgress || postValidateAddressInProgress;

  const { stateId } = formValues || {};

  const { AddressSuggestion } = result || {};

  const hasSuggestion = !!AddressSuggestion;

  const onCloseModal = () => {
    if (submitInProgress) return;
    clearPostValidateAddress();
    closeModal();
  }

  const {
    City,
    County,
    State,
    Street1,
    Street2,
    Zip1,
    Zip2,
  } = AddressSuggestion || {};

  const shippingState = hasSuggestion ?
    (states || []).find(x => x.stateShort.toUpperCase() == (State || '').toUpperCase()) :
    (states || []).find(x => x.stateId == stateId);

  const enteredState = (states || []).find(x => x.stateId == stateId);

  const restrictedState = hasAlcohol && !(shippingState || {}).offSiteShipping;

  const disabledIgnore = hasAlcohol && !(enteredState || {}).offSiteShipping;

  const handleValidationSkip = () => onSubmit(formValues);
  const onValidationSubmit = () => {
    const { stateId: sugggestedStateId } = (states || []).find(x => x.stateShort.toUpperCase() == (State || '').toUpperCase()) || {}
    const suggestion = {
      city: City,
      stateId: sugggestedStateId,
      address1: Street1,
      address2: Street2,
      zip: Zip1,
      zip_4: Zip2,
      countyName: County
    }
    onSubmit(Object.assign({}, formValues, suggestion));
  };

  
  return (
    <Modal show={openModal === 'ValidateAddressModal'} onHide={onCloseModal} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Confirm Address</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {inProgress && (
          <div style={{ textAlign: 'center' }}>
            <Loading />
          </div>
        )}
        {!inProgress && hasSuggestion && (
          <div>
            <p>
              {Street1} <br />
              {Street2 && (
                <span>{Street2}<br /></span>
              )}
              {City}, {State}<br />
              {Zip1}
              {Zip2 && (
                <span>-{Zip2}</span>
              )}
            </p>
          </div>
        )}
        {!inProgress && !hasSuggestion && !restrictedState && (
          <div>
            <p>
              <span style={{ color: '#dc3545' }}>Unable to validate address.</span>
              <br />
              Please verify shipping address before proceeding
            </p>
          </div>
        )}
        {!inProgress && restrictedState && (
          <div>
            <p>
              <span style={{ color: '#dc3545' }}>State does not allow alcohol shipments.</span>
              <br />
              Please verify shipping address before proceeding
            </p>
          </div>
        )}
        {!inProgress && !restrictedState && disabledIgnore && (
          <div>
            <p>
              <span style={{ color: '#dc3545' }}>Selected state does not allow alcohol shipments.</span>
              <br />
              Please use the suggested address to continue
            </p>
          </div>
        )}

        
      </Modal.Body>
      {!inProgress && restrictedState && (
        <Modal.Footer>
          <Button variant="secondary" onClick={onCloseModal} disabled={inProgress || submitInProgress}>
            OK
          </Button>
        </Modal.Footer>
      )}
      {!restrictedState && hasSuggestion && (
        <Modal.Footer>
          {!disabledIgnore && (
            <Button variant="secondary" onClick={handleValidationSkip} disabled={inProgress || disabledIgnore || submitInProgress}>
              Ignore
            </Button>
          )}
          <Button variant="primary" onClick={onValidationSubmit} disabled={inProgress || submitInProgress}>
            Yes, Use Suggestion
          </Button>
        </Modal.Footer>
      )}
      {!restrictedState && !hasSuggestion && (
        <Modal.Footer>
          <Button variant="primary" onClick={handleValidationSkip} disabled={inProgress || submitInProgress}>
            Continue
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
}

const mapState = state => ({ openModal: state.modals });
const mapDispatch = dispatch => bindActionCreators({
  ...actionCreators,
  clearPostValidateAddress: fetchDux.postValidateAddress.clearAction
}, dispatch);

export default connect(mapState, mapDispatch)(ValidateAddressModal);
